import { z } from "zod/v4";

import { AnalyzeCampaignRequestBodySchema } from "../../../schemas/analytics/analyze-campaign";
import { AnalyzeExperimentRequestBodySchema } from "../../../schemas/analytics/analyze-experiment";
import {
  AnalyticsResourceListSchema,
  DatasetIdList,
} from "../../../schemas/analytics/base";

export const AnalyzeResourceRequestBodySchema = z.discriminatedUnion(
  "resourceType",
  [AnalyzeExperimentRequestBodySchema, AnalyzeCampaignRequestBodySchema]
);

export type AnalyzeResourceRequestBodyType = z.infer<
  typeof AnalyzeResourceRequestBodySchema
>;

export const AnalyzeResourceResponseBodySchema = z.object({
  datasetId: z.enum(DatasetIdList),
  resourceType: z.enum(AnalyticsResourceListSchema),
  metrics: z.any().array(),
  loss: z.any(),
  latestRunTs: z.number(),
});

export type AnalyzeResourceResponseBodyType = z.infer<
  typeof AnalyzeResourceResponseBodySchema
>;
